import { VIEWS_MAP } from '@/screens/profile/profile-screen.constants.ts';

export const getMonthlyEarningContent = (activeView: keyof typeof VIEWS_MAP) => {
	const contentTypes = {
		[VIEWS_MAP.GOT_IT]: [
			{
				icon: 'icons-star',
				title: 'Görüşme başı ücretler ne kadardır?',
				description: <img src="/assets/got-it-payment-table.jpeg" />
			},
			{
				icon: 'icons-phone',
				title: 'Puanlanmayan görüşmeler nasıl hesaplanır?',
				description: (
					<div>
						<p>
							Öğrenciler yaptığınız görüşmeleri görüşmenin hemen ardından puanlayabildiği gibi her ayın takvim ayı son gününe kadar puanlayabilirler. Puanlanmamış görüşmeler için
							öğrenciler görüşme ardından ve takvim ayı son gününde hatırlatma bildirimi alır.
						</p>
						<p>
							Buna rağmen puanlanmamış görüşmeler mevcut ise ilgili ay ortalama puanınız baz alınarak görüşme ücretiniz hesaplanır ve her ayın 1'inde profilinizde "Puanlanmayan
							görüşmeler" satırında gösterilir.
						</p>
						<p>
							Puanlanmamış görüşmeleriniz aylık ortalama puanınız 1,00-1,99 arasında ise 1 puan; 2,00-2,99 arasında ise 2 puan; 3,00-3,74 arasında ise 3 puan; 3,75-4,49 arasında ise 4
							puan; 4,50 ve üzerinde ise 5 puan ile puanlanır.
						</p>
					</div>
				)
			},
			{
				icon: 'icons-hand-money',
				title: 'Minimum ödeme limiti nedir?',
				description: (
					<div>
						<p>Minimum ödeme limiti 1.500 TL'dir. İlgili ayda ödeme limitine ulaşılmadığında tutar bir ödeme limitine ulaşılana kadar bir sonraki aya devreder.</p>
					</div>
				)
			}
		],
		[VIEWS_MAP.GOT_IT_APPOINTMENTS]: [
			{
				icon: 'icons-star',
				title: 'Görüşme başı ücretler ne kadardır?',
				description: (
					<div>
						<div className="got-it-appointments-wrapper">
							<img src="/assets/got-it-payment-table.png" />
							<img src="/assets/got-it-appointment-payment-table.png" />
						</div>
						<div className="appointment-info-text">
							<ul>
								<li>ÖĞRENCİNİN GÖRÜŞMEYE KATILMASI İÇİN EN AZ 10 DAKİKA BEKLENMELİDİR.</li>
								<li>ÖĞRENCİ 10 DAKİKA SONUNDA HALA GÖRÜŞMEYE KATILMAMIŞSA, “Gerçekleşmedi - Öğrenci katılmadı” SEÇİMİ YAPILARAK GÖRÜŞME SONLANDIRILMALIDIR.</li>
								<li>ÖĞRENCİNİN KATILMADIĞI GÖRÜŞMEDEN 60 TL ÜCRET KAZANILIR.</li>
								<li>PLANLANAN GÖRÜŞMEYE ÖĞRENCİNİN KATILMADIĞI DURUMDA, KALAN SÜREDE ANLIK GÖRÜŞMELERE KATILIM SAĞLANMALIDIR.</li>
							</ul>
						</div>
					</div>
				)
			},
			{
				icon: 'icons-phone',
				title: 'Puanlanmayan görüşmeler nasıl hesaplanır?',
				description: (
					<div>
						<p>
							Öğrenciler yaptığınız görüşmeleri görüşmenin hemen ardından puanlayabildiği gibi her ayın takvim ayı son gününe kadar puanlayabilirler. Puanlanmamış görüşmeler için
							öğrenciler görüşme ardından ve takvim ayı son gününde hatırlatma bildirimi alır.
						</p>
						<p>
							Buna rağmen puanlanmamış görüşmeler mevcut ise ilgili ay ortalama puanınız baz alınarak görüşme ücretiniz hesaplanır ve her ayın 1'inde profilinizde "Puanlanmayan
							görüşmeler" satırında gösterilir.
						</p>
						<p>
							Puanlanmamış görüşmeleriniz aylık ortalama puanınız 1,00-1,99 arasında ise 1 puan; 2,00-2,99 arasında ise 2 puan; 3,00-3,74 arasında ise 3 puan; 3,75-4,49 arasında ise 4
							puan; 4,50 ve üzerinde ise 5 puan ile puanlanır.
						</p>
					</div>
				)
			},
			{
				icon: 'icons-hand-money',
				title: 'Minimum ödeme limiti nedir?',
				description: (
					<div>
						<p>Minimum ödeme limiti 1.500 TL'dir. İlgili ayda ödeme limitine ulaşılmadığında tutar bir ödeme limitine ulaşılana kadar bir sonraki aya devreder.</p>
					</div>
				)
			}
		],
		[VIEWS_MAP.COACHING]: [
			{
				icon: 'icons-star',
				title: 'Görüşme başı ücretler ne kadardır?',
				description: <img src="/assets/coach-payment-table.jpeg" />
			},
			{
				icon: 'icons-phone',
				title: 'Puanlanmayan görüşmeler nasıl hesaplanır?',
				description: (
					<div>
						<p>
							Öğrenciler yaptığınız görüşmeleri görüşmenin hemen ardından puanlayabildiği gibi her ayın takvim ayı son gününe kadar puanlayabilirler. Puanlanmamış görüşmeler için
							öğrenciler görüşme ardından ve takvim ayı son gününde hatırlatma bildirimi alır.
						</p>
						<p>
							Buna rağmen puanlanmamış görüşmeler mevcut ise ilgili ay ortalama puanınız baz alınarak görüşme ücretiniz hesaplanır ve her ayın 1'inde profilinizde "Puanlanmayan
							görüşmeler" satırında gösterilir.
						</p>
						<p>
							Puanlanmamış görüşmeleriniz aylık ortalama puanınız 1,00-1,99 arasında ise 1 puan; 2,00-2,99 arasında ise 2 puan; 3,00-3,74 arasında ise 3 puan; 3,75-4,49 arasında ise 4
							puan; 4,50 ve üzerinde ise 5 puan ile puanlanır.
						</p>
					</div>
				)
			},
			{
				icon: 'icons-hand-money',
				title: 'Minimum ödeme limiti nedir?',
				description: (
					<div>
						<p>Minimum ödeme limiti 1.500 TL'dir. İlgili ayda ödeme limitine ulaşılmadığında tutar bir ödeme limitine ulaşılana kadar bir sonraki aya devreder.</p>
					</div>
				)
			}
		],
		[VIEWS_MAP.SOLVER]: [
			{
				icon: 'icons-star',
				title: 'Soru başı ücretler ne kadar?',
				description: (
					<div>
						<p>Her bir soru için kazanacağınız ücret, aşağıdaki tabloda belirtilmiştir. Tablodaki ücretler puanınıza göre değişiklik gösterir.</p>
						<img src="/assets/solver-payment-table.png" />
					</div>
				)
			},
			{
				icon: 'icons-phone',
				title: 'Puanlanmayan sorular için ödeme nasıl yapılır?',
				description: (
					<div>
						<p>
							Öğrenciler, gönderdiğiniz çözüm videolarını hemen puanlayabilir ya da ay sonuna kadar süreleri vardır. Ay sonunda puanlamadıkları videolar için sistem onlara otomatik bir
							hatırlatma gönderir.
						</p>
						<p>
							Eğer buna rağmen bazı videolar puanlanmadıysa, bu videoların ücreti o ayki <b>ortalama puanınıza göre</b> hesaplanır ve her ayın 1'inde “Puanlanmayan Yanıt” başlığı altında
							profilinizde görünür.
						</p>
						<p>
							Puanlanmamış görüşmeleriniz aylık ortalama puanınız 1,00-1,99 arasında ise 1 puan; 2,00-2,99 arasında ise 2 puan; 3,00-3,74 arasında ise 3 puan; 3,75-4,49 arasında ise 4
							puan; 4,50 ve üzerinde ise 5 puan ile puanlanır.
						</p>

						<ul>
							<li>Ortalama puanınız 3,00 ile 3,74 arasındaysa → puanlanmayan çözümleriniz 3 puan üzerinden ücretlendirilir.</li>
							<li>Ortalama puanınız 3,75 ile 5,00 arasındaysa → bu çözümler 4 puan üzerinden ücretlendirilir.</li>
						</ul>
					</div>
				)
			},
			{
				icon: 'icons-hand-money',
				title: 'Minimum ödeme limiti nedir?',
				description: (
					<div>
						<p>
							Ödeme alabilmeniz için ay sonunda kazancınızın en az <b>1.500 TL</b> olması gerekir. Bu limite ulaşılamazsa kazancınız bir sonraki aya devredilir ve limit tamamlandığında
							ödeme yapılır.
						</p>
					</div>
				)
			}
		],
		[VIEWS_MAP.COACHING_APPOINTMENTS]: [
			{
				icon: 'icons-star',
				title: 'Görüşme başı ücretler ne kadardır?',
				description: (
					<div>
						<div className="coaching-appointments-wrapper">
							<img src="/assets/coach-payment-table.png" />
							<img src="/assets/coach-appointment-payment-table.png" />
						</div>
						<div className="appointment-info-text">
							Katılım olmayan görüşmeler ay sonunda toplam görüşmelerin %10'u kadarınca hesaplanır ve bir katılım olmayan görüşme bedeli 70 TL'dir.
						</div>
					</div>
				)
			},
			{
				icon: 'icons-phone',
				title: 'Puanlanmayan görüşmeler nasıl hesaplanır?',
				description: (
					<div>
						<p>
							Öğrenciler yaptığınız görüşmeleri görüşmenin hemen ardından puanlayabildiği gibi her ayın takvim ayı son gününe kadar puanlayabilirler. Puanlanmamış görüşmeler için
							öğrenciler görüşme ardından ve takvim ayı son gününde hatırlatma bildirimi alır.
						</p>
						<p>
							Buna rağmen puanlanmamış görüşmeler mevcut ise ilgili ay ortalama puanınız baz alınarak görüşme ücretiniz hesaplanır ve her ayın 1'inde profilinizde "Puanlanmayan
							görüşmeler" satırında gösterilir.
						</p>
						<p>Aylık ortalama puanınız 3,00-3,74 arasında ise puanlanmamış görüşmeleriniz 3 puan olarak 3,75-5,00 arasında ise puanlanmamış görüşmeleriniz 4 puan olarak puanlanır.</p>
					</div>
				)
			},
			{
				icon: 'icons-user-cross',
				title: 'Katılım olmayan görüşmelerden nasıl kazanç sağlanır?',
				description: (
					<div>
						<p>
							Katılım olmayan görüşme oranınızın aylık %10'u kadar tarafınıza ödeme yapılır. %10 üzeri için ödeme yapılmaz. Her ayın 1'inde hesaplanan ücretler profilinizde "Katılım
							olmayan görüşme" satırında gösterilir.
						</p>
					</div>
				)
			},
			{
				icon: 'icons-hand-money',
				title: 'Minimum ödeme limiti nedir?',
				description: (
					<div>
						<p>Minimum ödeme limiti 1.500 TL'dir. İlgili ayda ödeme limitine ulaşılmadığında tutar bir ödeme limitine ulaşılana kadar bir sonraki aya devreder.</p>
					</div>
				)
			}
		]
	};

	return contentTypes[activeView] || contentTypes[VIEWS_MAP.GOT_IT];
};
